/* eslint-disable camelcase */
export function spHomepageContentView({ name, position }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_homepage_content_view',
        content_block: name,
        content_block_position: position.toString()
    });
}